import styles from './ErrorLabel.module.scss'
export const ErrorLabel = ({ label }) => {
  return (
    <span className={styles['text']} role='alert'>
      {label}
    </span>
  )
}
